import { render, staticRenderFns } from "./blank_state.vue?vue&type=template&id=5631804a&"
import script from "./blank_state.vue?vue&type=script&lang=js&"
export * from "./blank_state.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "blank_state.vue"
export default component.exports